module.exports = __webpack_public_path__ + "static/media/usage_bag.8d75eaca.png";